import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableNewOrderImport = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableNewOrderImport);
};
